import { render, staticRenderFns } from "./EmailSender.vue?vue&type=template&id=87af94b8&scoped=true"
import script from "./EmailSender.vue?vue&type=script&lang=js"
export * from "./EmailSender.vue?vue&type=script&lang=js"
import style0 from "./EmailSender.vue?vue&type=style&index=0&id=87af94b8&prod&lang=scss"
import style1 from "./EmailSender.vue?vue&type=style&index=1&id=87af94b8&prod&scoped=true&lang=css"
import style2 from "./EmailSender.vue?vue&type=style&index=2&id=87af94b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87af94b8",
  null
  
)

export default component.exports